import React from 'react';
import { arrayOf, bool, func, shape } from 'prop-types';

import Box from '@mui/material/Box';

import { NoAvailableCard } from 'common';

import TerminalCard from './TerminalCard/TerminalCard';

const styles = {
  terminalList: {
    overflowY: 'auto',
  },
};

const TerminalList = ({
  isLoadingTerminals,
  location,
  setSelectedTerminal,
  sx,
  terminals,
  ...props
}) => (
  <Box sx={{ ...styles.terminalList, ...sx }} {...props}>
    {!isLoadingTerminals ? (
      terminals.length ? (
        terminals.map(terminal => (
          <TerminalCard
            key={terminal.terminalId}
            location={location}
            setSelectedTerminal={setSelectedTerminal}
            terminal={terminal}
          />
        ))
      ) : (
        <NoAvailableCard type="terminals" />
      )
    ) : (
      <>
        <TerminalCard />
        <TerminalCard />
        <TerminalCard />
        <TerminalCard />
        <TerminalCard />
      </>
    )}
  </Box>
);

TerminalList.propTypes = {
  isLoadingTerminals: bool.isRequired,
  location: shape({}),
  setSelectedTerminal: func.isRequired,
  sx: shape({}),
  terminals: arrayOf(shape({})),
};

TerminalList.defaultProps = {
  location: null,
  sx: null,
  terminals: null,
};

export default TerminalList;
